const PackagePoster = [
    {
        "packageId":1,
        "poster":"https://www.growniverse.com/images//Basic_Package.webp"
    },
    {
        "packageId":2,
        "poster":"https://www.growniverse.com/images//Advanced_Package.webp"
    },
    {
        "packageId":3,
        "poster":"https://www.growniverse.com/images//Silver_Package.webp"
    },
    {
        "packageId":4,
        "poster":"https://www.growniverse.com/images//Gold_Package.webp"
    },
    {
        "packageId":5,
        "poster":"https://www.growniverse.com/images//Platinum_Package.webp"
    }
]

export default PackagePoster;